import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../componentes/Header";
import Footer from "../componentes/Footer";
import Projeto from "../componentes/Projeto";
import ProjetoDestaque from "../componentes/ProjetoDestaque";
import Contato from "../componentes/Contato";
import Reveal from "../componentes/Reveal";
import projetos from "../data/projetos";
import {
  ArrowRight,
  Layout,
  Database,
  Bot,
  Briefcase,
  GraduationCap,
  Sparkles,
} from "../componentes/Icons";

const STACK = [
  "Next.js",
  "React",
  "TypeScript",
  "Node.js",
  "PostgreSQL",
  "Supabase",
  "Prisma",
  "n8n",
  "Tailwind CSS",
  "IA / RAG",
];

const HERO_STATS = [
  { k: "Full-stack", v: "Next.js · React · Node · TypeScript" },
  { k: "Dados & BI", v: "PostgreSQL · Supabase · ETL" },
  { k: "IA & Automação", v: "n8n · RAG · WhatsApp" },
];

const SKILLS = [
  {
    grupo: "Frontend",
    itens: ["React", "Next.js", "TypeScript", "Tailwind CSS", "PrimeReact", "HTML / CSS"],
  },
  {
    grupo: "Backend & Dados",
    itens: ["Node.js", "PostgreSQL", "Supabase", "Prisma", "REST APIs", "RLS / RPC"],
  },
  {
    grupo: "Automação & IA",
    itens: ["n8n", "RAG / pgvector", "WhatsApp API", "Web Scraping", "Whisper"],
  },
];

const EXPERIENCIA = [
  {
    when: "2025 — Atual",
    titulo: "Desenvolvedor Full-stack · Setor Financeiro",
    desc: "Desenvolvimento de sistemas de controle interno em uma instituição de investimentos financeiros.",
  },
  {
    when: "2025 · Freelance",
    titulo: "Desenvolvedor de Automação · Imobiliário",
    desc: "Criação de ecossistemas inteligentes para triagem, BI e consulta técnica automatizada integrados a CRM e WhatsApp.",
  },
  {
    when: "2023 — 2025",
    titulo: "Desenvolvedor Front-end · Auditoria",
    desc: "Participação no desenvolvimento de sistemas de análise e auditoria fiscal.",
  },
];

const FORMACAO = [
  {
    when: "2022 — 2024",
    titulo: "Análise e Desenvolvimento de Sistemas",
    desc: "Graduação focada em fundamentos de software, arquitetura e lógica.",
  },
  {
    when: "2025",
    titulo: "Full Stack JavaScript · OneBitCode",
    desc: "Especialização prática nas tecnologias modernas do ecossistema JS.",
  },
  {
    when: "2025",
    titulo: "Automação e NoCode · n8n e IA",
    desc: "Aprofundamento em fluxos inteligentes e integração de Inteligência Artificial.",
  },
];

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        setTimeout(
          () => section.scrollIntoView({ behavior: "smooth" }),
          100
        );
      }
    }
  }, [location]);

  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div>
      <Header />

      {/* ---------------------------------- Hero ---------------------------------- */}
      <section className="hero" id="home">
        <div className="container">
          <div className="hero-inner">
            <div>
              <div className="hero-status">
                <span className="badge badge-ok">
                  <span className="badge-dot badge-dot--pulse" /> Disponível para
                  novos projetos
                </span>
              </div>

              <h1>
                <span>Bruno Rodrigues</span>
                <span className="grad-text">Desenvolvedor Full-stack</span>
              </h1>

              <p className="hero-lead">
                Construo <strong>produtos completos e escaláveis</strong> — do
                banco de dados à interface — com foco em{" "}
                <strong>dados, automação e IA aplicada</strong>.
              </p>

              <div className="hero-cta">
                <button
                  className="btn btn-primary"
                  onClick={() => scrollTo("projetos")}
                >
                  Ver projetos <ArrowRight />
                </button>
                <button
                  className="btn btn-ghost"
                  onClick={() => scrollTo("contato")}
                >
                  Entrar em contato
                </button>
              </div>

              <div className="hero-stats">
                {HERO_STATS.map((s) => (
                  <div className="hero-stat" key={s.k}>
                    <div className="k">{s.k}</div>
                    <div className="v">{s.v}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="hero-visual">
              <div className="hero-portrait">
                <img src="/avatar-bruno.png" alt="Bruno Rodrigues" />
                <div className="hero-portrait-tag">
                  <span className="role">Bruno Rodrigues</span>
                  <span className="loc">Joinville · SC</span>
                </div>
              </div>

              <div className="hero-float hero-float--b">
                <span className="ic">
                  <Bot />
                </span>
                <span>
                  IA &amp; Automação
                  <small>em produção</small>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------------------- Marquee -------------------------------- */}
      <div className="marquee">
        <div className="marquee-track">
          {[...STACK, ...STACK].map((s, i) => (
            <span className="marquee-item" key={i}>
              {s}
            </span>
          ))}
        </div>
      </div>

      {/* ---------------------------------- Sobre --------------------------------- */}
      <section className="section" id="sobre">
        <div className="container">
          <Reveal className="section-head">
            <span className="eyebrow">Sobre mim</span>
            <h2>Da modelagem de dados à interface final</h2>
            <p>
              Desenvolvedor web full-stack apaixonado por resolver problemas
              reais de negócio com software bem arquitetado.
            </p>
          </Reveal>

          <div className="about-grid">
            <Reveal className="about-col">
              <h3>Me conheça</h3>
              <p>
                Sou <strong>Desenvolvedor Full-stack</strong> e crio soluções de
                ponta a ponta: do planejamento do banco de dados até a interface,
                garantindo <strong>performance e qualidade técnica</strong>.
              </p>
              <p>
                Tenho forte interesse por <strong>engenharia de dados</strong>,{" "}
                <strong>Business Intelligence</strong> e{" "}
                <strong>IA aplicada</strong> — sempre buscando otimizar fluxos com{" "}
                <strong>n8n</strong> e arquiteturas modernas com{" "}
                <strong>Next.js, Supabase e Prisma</strong>.
              </p>
              <p>
                Gosto de compartilhar conhecimento no{" "}
                <a
                  href="https://www.linkedin.com/in/bruno-rodrigues-609146181/"
                  target="_blank"
                  rel="noreferrer"
                >
                  LinkedIn
                </a>
                , onde posto conteúdo sobre desenvolvimento web e programação.
              </p>

              <div style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 26 }}>
                <span className="chip" style={{ alignSelf: "flex-start" }}>
                  <Layout width={18} height={18} /> Produtos &amp; UI
                </span>
                <span className="chip" style={{ alignSelf: "flex-start" }}>
                  <Database width={18} height={18} /> Modelagem &amp; BI
                </span>
                <span className="chip" style={{ alignSelf: "flex-start" }}>
                  <Bot width={18} height={18} /> IA &amp; Automação
                </span>
              </div>
            </Reveal>

            <Reveal className="about-col" delay={120}>
              <h3>Minhas skills</h3>
              <div className="skills-groups">
                {SKILLS.map((g) => (
                  <div className="skills-group" key={g.grupo}>
                    <h4>{g.grupo}</h4>
                    <div className="skills-list">
                      {g.itens.map((s) => (
                        <span className="chip" key={s}>
                          <span className="chip-dot" />
                          {s}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* -------------------------------- Projetos -------------------------------- */}
      <section className="section" id="projetos" style={{ background: "var(--bg-soft)" }}>
        <div className="container">
          <Reveal className="section-head section-head--center">
            <span className="eyebrow" style={{ justifyContent: "center" }}>
              <Sparkles width={14} height={14} /> Portfólio
            </span>
            <h2>Projetos selecionados</h2>
            <p style={{ marginLeft: "auto", marginRight: "auto" }}>
              Uma seleção de produtos que desenvolvi — de plataformas de BI a apps
              full-stack em produção.
            </p>
          </Reveal>

          <Reveal>
            <ProjetoDestaque />
          </Reveal>

          <div className="proj-grid">
            {projetos.map((p, i) => (
              <Reveal key={p.id} delay={(i % 2) * 90}>
                <Projeto {...p} num={String(i + 2).padStart(2, "0")} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ------------------------------- Trajetória ------------------------------- */}
      <section className="section" id="trajetoria">
        <div className="container">
          <Reveal className="section-head">
            <span className="eyebrow">Trajetória</span>
            <h2>Experiência &amp; formação</h2>
            <p>Um resumo da minha jornada profissional e acadêmica.</p>
          </Reveal>

          <div className="timeline">
            <Reveal className="timeline-col">
              <h3>
                <span className="ic">
                  <Briefcase />
                </span>
                Experiência
              </h3>
              <div className="tl-items">
                {EXPERIENCIA.map((e) => (
                  <div className="tl-item" key={e.titulo}>
                    <span className="when">{e.when}</span>
                    <h4>{e.titulo}</h4>
                    <p>{e.desc}</p>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal className="timeline-col" delay={120}>
              <h3>
                <span className="ic">
                  <GraduationCap />
                </span>
                Formação
              </h3>
              <div className="tl-items">
                {FORMACAO.map((f) => (
                  <div className="tl-item" key={f.titulo}>
                    <span className="when">{f.when}</span>
                    <h4>{f.titulo}</h4>
                    <p>{f.desc}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* -------------------------------- Contato --------------------------------- */}
      <Contato />

      <Footer />
    </div>
  );
}

export default Home;
